import {SerializedStyles} from '@emotion/react';
import {css, Typography, TypographyProps, useTheme} from '@mui/material';
import React from 'react';
import {useIntl} from 'react-intl';
import {GetStylesFunction} from 'src/js/common/types';
import {TranslateUtils} from 'src/js/common/utils';

interface OwnProps extends TypographyProps {
  inputCss?: SerializedStyles;
  title: string;
  regular?: boolean;
  disabledTooltip?: string;
}

type Props = OwnProps;

export const DlMuiTextWhiteButton: React.FC<Props> = (props) => {
  const {inputCss, title, regular, onClick, disabledTooltip: _, ...restProps} = props;
  const theme = useTheme();
  const intl = useIntl();
  const styles = getStyles({theme, params: {onClick, inputCss}});

  const translatedTitle = TranslateUtils.translate(title, intl);

  return (
    <Typography
      variant={regular ? 'textButtonRegular' : 'textButton'}
      data-name={'dl-mui-chip-button--chip'}
      {...restProps}
      css={styles.textButton}
      onClick={onClick}
    >
      {translatedTitle}
    </Typography>
  );
};

DlMuiTextWhiteButton.displayName = 'DlMuiTextWhiteButton';

const getStyles: GetStylesFunction = (options) => ({
  textButton: css`
    color: white;
    text-decoration: ${options?.params?.onClick ? 'underline' : 'none'};
    cursor: ${options?.params?.onClick ? 'pointer' : 'default'};

    &:hover,
    &:focus {
      color: white;
    }

    &:active {
      color: white;
    }

    ${options?.params?.inputCss ?? ''};
  `,
});
